import { has, isEmpty } from 'lodash';

import { adaptGroupFilter } from '@/components/FilterManager/EntityFilter/utils';
import { FilterState } from '@/components/FilterManager/types';
import { ResourceStatusEnum, ResourceTypeEnum } from '@/types/schema';

import { LearningContentPageFilters } from '../types';
import { CONTENT_SORT_DEFAULT_VALUE } from './getSortAndFilterItems';

const defaultFilters = {
  [LearningContentPageFilters.ACTIVE]: {
    types: [],
  },
  [LearningContentPageFilters.ARCHIVED]: {
    types: [],
  },
  [LearningContentPageFilters.DRAFT]: {
    types: [ResourceTypeEnum.Course, ResourceTypeEnum.Article],
  },
  [LearningContentPageFilters.RECENT]: {
    types: [],
    userRecents: true,
  },
};

const defaultStatusFilter = {
  [LearningContentPageFilters.ACTIVE]: {
    status: [
      ResourceStatusEnum.Draft,
      ResourceStatusEnum.Published,
      ResourceStatusEnum.UnpublishedChanges,
    ],
  },
  [LearningContentPageFilters.ARCHIVED]: {
    status: [ResourceStatusEnum.Archived, ResourceStatusEnum.Revoked],
  },
  [LearningContentPageFilters.DRAFT]: {
    status: [ResourceStatusEnum.Draft, ResourceStatusEnum.UnpublishedChanges],
  },
  [LearningContentPageFilters.RECENT]: {},
};

export default function getDefaultFilters(pageFilter: LearningContentPageFilters) {
  return defaultFilters[pageFilter];
}

export const getFilters = (filter: FilterState, pageFilter: LearningContentPageFilters) => {
  if (!has(filter, 'status') || isEmpty(filter.status)) {
    return { ...filter, ...defaultStatusFilter[pageFilter] };
  }

  return filter;
};

export const getDefaultSort = (pageFilter: LearningContentPageFilters) => {
  if (
    pageFilter === LearningContentPageFilters.ACTIVE ||
    pageFilter === LearningContentPageFilters.ARCHIVED ||
    pageFilter === LearningContentPageFilters.DRAFT
  ) {
    return CONTENT_SORT_DEFAULT_VALUE;
  }
  return undefined;
};

export const adaptContentFilters = (filter: any, pageFilter: LearningContentPageFilters) => ({
  ...getFilters(filter, pageFilter),
  groupFilter: adaptGroupFilter(filter.groupFilter),
});
